<template>
  <div id="cliente-container" class="cliente">
      <v-toolbar flat class="sub-toolbar">
        <v-btn
          text
          flat
          class="mr-auto"
          color="primary"
          @click="alert = !alert">
          <v-icon class="mr-2">manage_accounts</v-icon>
          {{cliente.nombre}}
        </v-btn>
      </v-toolbar>
      <div class="cliente-container d-flex">
      <v-alert
        :value="alert"
        type="transparet"
        transition="scale-transition">
        <v-btn
            flat
            icon
            text
            color="primary"
            dark
            @click="alert = false"
            class="ml-auto mr-0 d-flex"
          >
            <v-icon>close</v-icon>
          </v-btn>
    <cliente-sidebar :cliente="cliente"/>
      </v-alert>
    <cliente-main/>
    </div>
  </div>
</template>
<script>
import ClienteMain from './components/main/ClienteMain.vue';
import ClienteSidebar from './components/sidebar/ClienteSidebar';
import { ClienteApiService } from '@/api/ClienteApiService';
const clienteApiService = new ClienteApiService()
export default {
  name: 'cliente',
  components: {
    ClienteSidebar,
    ClienteMain
  },
  data() {
    return {
      clienteAux: {},
      activeBtn: 1,
      showNav: true ,
      alert: true ,
    }
  },
  computed: {
    cliente () {
      return this.$store.getters.getCliente
    }
  },
  watch: {
    cliente(value) {
      if (value !== null) {
        this.init()
      }
    }
  },
  created() {
    this.cambioTitulo()
    this.init()
  },
  methods: {
    cambioTitulo() {
      this.$store.state.tituloIcono = '<v-icon class="primary-color v-icon material-icons no-flex">person_pin_circle</v-icon>'
      this.$store.state.titulo = 'Cliente'
    },
    init() {
      this.getClienteById()
    },
    getClienteById() {
      clienteApiService.getClienteById(this.cliente.id)
        .then(data => {
          console.log(data)
          this.clienteAux = data
        })
        .catch(error => {
          console.log('clienteApiService - getClienteById', error, 'ERROR')
        })
    }
  },
}
</script>
<style lang="scss">


        
</style>
